import logbookService from "@/services/dailyLogbook";
const getDefaultState = () => {
  return {
    dashboardData: null,
  }
}

export const state = getDefaultState();

export const actions = {
  async fetchDashboardData({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getDashboardData()
        .then((data) => {
          resolve(data);
          commit("setDashboardData", data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchHistoryData({ commit }) {
    commit("grid/setLoading", false, { root: true });
    return new Promise((resolve, reject) => {
      logbookService
        .getHistoryData()
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const mutations = {
  setDashboardData(state, payload) {
    state.dashboardData = payload;
  },
};

export const getters = {
  getDashboardData(state) {
    return state.dashboardData;
  },
};
